import {
    CompanySettings, ConfigSettings, CurrencySettings, GeneralSettings, LicenseSettings, SettingsRegistry, UserSettings
} from "@mcleod/core";

export class ImagingSettingsInitializer {
    public initialize() {
        const settingsRegistry = SettingsRegistry.get();
        settingsRegistry.register(
            new ConfigSettings(),
            new GeneralSettings(),
            new CompanySettings(),
            new UserSettings(),
            new LicenseSettings(),
            new CurrencySettings()
        );
        settingsRegistry.settingsRoot = "imaging/";
    }
}
